import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { useT } from "@/i18n";
import { framesFlightMessages } from "@/i18n/messages/frames-flight";
import { cardPaint } from "../shared/card-paint";
import { FrameEmptyState } from "../shared/frame-empty-state";
import { ObjectFrame, ObjectFrameLoading } from "../shared/object-frame";
import { flightFields, hasFlight } from "./flight-content";
import { FlightFace } from "./flight-face";

/** A flight: its card, larger, then the boarding pass the agent supplied. */
export function FlightFrame({ id, data }: FrameProps) {
  const t = useT(framesFlightMessages);
  const fields = flightFields(data.content ?? {});
  const shown = hasFlight(fields);
  return (
    <ObjectFrame id={id} paint={cardPaint(data)} testId="flight-frame">
      {shown ? (
        <FlightFace
          fields={fields}
          density="regular"
          opened
          testIdPrefix="flight-frame"
        />
      ) : data.status === "streaming" ? (
        <ObjectFrameLoading testId="flight-frame-loading">
          {t("fetchingFlight")}
        </ObjectFrameLoading>
      ) : (
        <FrameEmptyState
          frameId={id}
          status={data.status}
          testId="flight-frame-empty"
        >
          {t("noFlight")}
        </FrameEmptyState>
      )}
    </ObjectFrame>
  );
}
